import classNames from "classnames";
import { memo, MouseEventHandler } from "react";
import { Glyph } from "../../types";
import styles from "./Icon.module.css";

interface Props {
  glyph: Glyph;
  className?: string;
  onClick?: MouseEventHandler;
  fill?: string;
  color?: "yellow" | "red" | "green" | "blue" | "grey";
}

const Icon = ({ glyph: Glyph, className, onClick, fill, color }: Props) => {
  return (
    <Glyph
      className={classNames(styles.icon, className, {
        [styles.green]: color === "green",
        [styles.red]: color === "red",
        [styles.blue]: color === "blue",
        [styles.yellow]: color === "yellow",
        [styles.grey]: color === "grey",
      })}
      onClick={onClick}
      fill={fill}
    />
  );
};

export default memo(Icon);
